import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import ReparcelamentoForm from '../components/ReparcelamentoForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import Reparcelamento from '../tutoriais/LancReparcelamento';

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalTit: 0,
    qtdeTit: 0,
    formVisivel: false,
    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'REP',
      buscaOrdem: { campo: 'tit_data_emissao', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'A', },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
      buscaCondPagto: { key: '0' },
    }

  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalTit: 0, qtdeTit: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaSituacao, buscaDescricao, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/titulos', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          controle: buscaControle,
          numero: buscaNumero,
          descricao: buscaDescricao,
          tipo: buscaTipo.key,
          situacao: buscaSituacao.key,
          pessoa: buscaPessoa.key,
          ctaFin: buscaPlanoCta.key,
          dataIni,
          dataFim,
          tipoTela: ''
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };


  onSalvarClick = (registro) => {
    // console.log('Registro gravar: ', registro);
    // return;

    this.setState({ salvando: true })
    axios.put(`/titulos/updateParcelas/${registro.tit_idf}`, registro)
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }


  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/titulos/show/${registro.tit_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.tit_pessoa = {
          key: data.dados.tit_pessoa,
          label: data.dados.pes_nome,
        }
        data.dados.tit_tipo_doc = {
          key: data.listaParcelas[0].tparc_tipo_doc,
          label: data.listaParcelas[0].td_descricao,
        }
        data.dados.tit_cond_pagto = {
          key: data.dados.tit_cond_pagto,
          label: data.dados.cp_descricao,
        }
        data.dados.tit_plano_conta = {
          key: data.dados.tit_plano_conta,
          label: data.dados.pc_descricao,
        }
        data.dados.tit_cta_corrente = {
          key: data.listaParcelas[0].tparc_conta_corrente,
          label: data.listaParcelas[0].cc_descricao,
        }
        data.dados.tit_data_emissao = moment(data.dados.tit_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.tit_tipo = {
          key: data.dados.pc_tipo,
          label: data.dados.pc_tipo === 'E' ? 'Entrada' : 'Saída',
        }

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
        buscaCondPagto: this.state.filtros.buscaCondPagto,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Reparcelar">
          <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  renderValor = (tit_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(tit_vlr_total)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, formFiltroVisivel, salvando,
      registroSelecionado, filtros, total, pagina, limite } = this.state;

    // console.log('ReparcelamentoPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Reparcelamento Financeiro</span>
          <div>
            <Tooltip title="Video de Ajuda">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=rFODcKXLgMs&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=5', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 35 }}>

            <Col xs={2} style={{ width: 110 }}>
              <Button
                type="primary"
                onClick={this.onAbrirFiltroClick}
                className="botao-primary"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>
            </Col>

            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <ReparcelamentoForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

            <Reparcelamento
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>
        </Row>

        <Row>
          <div style={{ paddingTop: 0 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf)}
            >
              <Column
                key="tit_controle"
                dataIndex="tit_controle"
                title={this.renderTitulo("Controle")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_numero"
                dataIndex="tit_numero"
                title={this.renderTitulo("Número")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_valor"
                dataIndex="tit_valor"
                title={this.renderTitulo("Valor")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="tit_data_emissao"
                dataIndex="tit_data_emissao"
                title={this.renderTitulo("Emissão")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={120}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title={this.renderTitulo("Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_descricao"
                dataIndex="pc_descricao"
                title={this.renderTitulo("Conta Financeia")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title={this.renderTitulo("Descrição")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
                render={this.renderAcoes}
                width={70}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ReparcelamentoPage.js